// Pages where notification toasts are not shown. The AI app consent page (/ai/connect) is seen by
// third-party app reviewers mid-OAuth, so an unrelated "Data Aggregation Complete" popup is noise.
const TOAST_SUPPRESSED = /^\/ai\/connect(\/|$)/;

export const isToastSuppressedPath = (pathname) => TOAST_SUPPRESSED.test(String(pathname || ''));
